export enum SiteListSelectionMode {
  Include = "INCLUDE",
  Exclude = "EXCLUDE",
}
